hb-dear {
    video.no-play-button::-webkit-media-controls-start-playback-button {
        display: none !important;
        -webkit-appearance: none !important;
    }
}
